$('.color-swatch').mouseover(function(){
	$(this).addClass('is_able');
    $(this).siblings().removeClass('is_able')
})



$(document).on('scroll', function () {
  
  var obj = $('.open_path');
  if ( obj.length > 0 ) {
    var clientHeight = $(window).height();
    var scrollTop = $(document).scrollTop();
    var offsetTop = obj.offset().top;
    var objHeight = obj.height();
    if(offsetTop + 100 < scrollTop + clientHeight && offsetTop + objHeight > scrollTop) {
      $('.huangquan').addClass('path');
    }else{
      $('.huangquan').removeClass('path');
    }
  }
})


// $('.variant-wrapper--dropdown select').change(function(){
//   var size_text=$(".variant-wrapper--dropdown select option:selected").text();
//   $('#VariantsizeLabel').text(size_text);
// });

$(document).ready(function(){
  let lastIndex = 0;
  $("#custom-faqs .title").click(function(){
    let nowIndex = $("#custom-faqs").children().index($(this).parent());
	
    if(nowIndex == lastIndex)
    {
      if($(this).parent().find(".content").is(":hidden"))
      {
        $(this).find("img").attr("src", "https://cdn.shopify.com/s/files/1/0506/8934/3650/files/Minus_sign.svg?v=1605234007");
        $(this).parent().find(".content").slideDown(300);
      }
      else
      {
        $(this).find("img").attr("src", "https://cdn.shopify.com/s/files/1/0506/8934/3650/files/plus.svg?v=1605234007");
        $(this).parent().find(".content").slideUp(300);
      }
    }
    else
    {
      if(lastIndex != null)
      {

        $("#custom-faqs").children().eq(lastIndex).find("img").attr("src", "https://cdn.shopify.com/s/files/1/0506/8934/3650/files/plus.svg?v=1605234007");
        $("#custom-faqs").children().eq(lastIndex).find(".content").slideUp(300);
      }

      $(this).find("img").attr("src", "https://cdn.shopify.com/s/files/1/0506/8934/3650/files/Minus_sign.svg?v=1605234007");
      $(this).parent().find(".content").slideDown(300);
    }

    lastIndex = nowIndex;
  });
  if($(".swiper-height").length>0){
  	var info = $(".swiper-height .grid-product__image-mask").height()/2+20;
    $('.swiper-height .flickity-button').css('top',info+'px')
  }
})


function copyUrl2(){
var Url2=document.getElementById("discount_code").innerText;
document.getElementById("change_copy_close").click()
var oInput = document.createElement('input');
oInput.value = Url2;
document.body.appendChild(oInput);
oInput.select(); 
document.execCommand("Copy"); 
oInput.className = 'oInput';
oInput.style.display='none';

}